(() => {
  'use strict';
  const copyElement = document.getElementById('mm-atelier-copy');
  if (!copyElement) return;
  let copy;
  try { copy = JSON.parse(copyElement.textContent); } catch (_) { return; }
  const scope = document.querySelector('main') || document.body;
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const namePattern = /prenom.*broder|name.*embroider/;
  const colorPattern = /couleur du fil|thread colou?r/;
  const findLabel = field => field.querySelector('.tpo_option-label-container');
  const text = (tag, className, content) => {
    const element = document.createElement(tag);
    element.className = className;
    element.textContent = content;
    return element;
  };
  function refreshColor(field) {
    const output = field.querySelector('.mm-atelier-selected');
    if (!output) return;
    const checked = field.querySelector('input[type="radio"]:checked');
    const swatch = checked && checked.closest('.tpo_swatches-label_position, .tpo_color-swatches-label_position, .tpo_image-swatches-wrapper');
    const label = swatch && swatch.querySelector('.tpo-swatch-option-label, .tpo_option_type_label');
    const value = label ? label.textContent.trim() : '';
    if (output.textContent !== value) output.textContent = value;
  }
  function enhance(optionSet) {
    const fields = [...optionSet.querySelectorAll('.tpo_option-container')];
    const nameField = fields.find(field => {
      const input = field.querySelector('input.tpo_text-box, textarea.tpo_text-box');
      if (!input) return false;
      const label = findLabel(field);
      return namePattern.test(normalize(input.name + ' ' + input.id + ' ' + (label ? label.textContent : '')));
    });
    const colorField = fields.find(field => {
      const label = findLabel(field);
      return field.querySelector('input.tpo_image-swatches-input[type="radio"], input.tpo_color-swatches-input[type="radio"]')
        && label && colorPattern.test(normalize(label.textContent));
    });
    if (!nameField || !colorField || nameField.parentElement !== colorField.parentElement
        || nameField.nextElementSibling !== colorField) return;
    const radios = [...colorField.querySelectorAll('input.tpo_image-swatches-input[type="radio"], input.tpo_color-swatches-input[type="radio"]')];
    const swatches = [...new Set(radios.map(input => input.closest('.tpo_swatches-label_position, .tpo_color-swatches-label_position, .tpo_image-swatches-wrapper')))];
    if (swatches.length < 2 || swatches.some(swatch => !swatch)) return;
    const palette = swatches[0].parentElement;
    if (swatches.some(swatch => swatch.parentElement !== palette)) return;
    optionSet.classList.add('mm-atelier-ready');
    nameField.classList.add('mm-atelier-name');
    colorField.classList.add('mm-atelier-colors');
    palette.classList.add('mm-atelier-palette');
    swatches.forEach(swatch => {
      swatch.classList.add('mm-atelier-swatch');
      swatch.querySelectorAll('.tpo_option_type_description').forEach(description => {
        if (!description.textContent.trim()) description.classList.add('mm-atelier-empty');
      });
    });
    if (!nameField.querySelector('.mm-atelier-heading')) {
      const heading = document.createElement('div');
      heading.className = 'mm-atelier-heading';
      const price = document.createElement('div');
      price.className = 'mm-atelier-price';
      price.append(text('span', 'mm-atelier-price-value', copy.price), text('span', 'mm-atelier-price-unit', copy.unit));
      heading.append(text('p', 'mm-atelier-title', copy.heading), price);
      nameField.prepend(heading);
    }
    const label = findLabel(colorField);
    if (label && !label.querySelector('.mm-atelier-selected')) {
      const output = text('span', 'mm-atelier-selected', '');
      output.setAttribute('aria-live', 'polite');
      label.append(output);
    }
    if (!colorField.querySelector('.mm-atelier-note')) {
      colorField.append(text('p', 'mm-atelier-note', copy.note));
    }
    refreshColor(colorField);
  }
  function scan() {
    scope.querySelectorAll('.product__info-container .tpo_option-set-container').forEach(enhance);
  }
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; scan(); });
  });
  scan();
  observer.observe(scope, {childList: true, subtree: true});
  scope.addEventListener('change', event => {
    const field = event.target.closest && event.target.closest('.mm-atelier-colors');
    if (field) refreshColor(field);
  });
})();
